import React from "react"
import { connect } from "react-redux"
import {find, isEqual, flatten, isString, keys} from "lodash"
import { replace } from 'connected-react-router'
import { Button, Table, Modal, FormControl } from "react-bootstrap"
import { parse, stringify } from "query-string"
import moment from "moment"
import Json from "react-json-view"

import { getSessionsInf } from '../../store/selectors'
import { restaurants } from "../../../../../data"
import { Pager } from "./table.aux"

import "./tables.less"

function renderTrackMessage(path) {
  const splittedPath = path.split("/")
  const last = splittedPath[splittedPath.length - 1]
  const penultimate = splittedPath[splittedPath.length - 2]

  if (last == "catalogo") return "Ha entrado al catalogo"
  else if (last == "restaurants") return "Ha ido a ver los restaurantes"
  else if (penultimate == "restaurant") return `Ha ido a ver la descripcion de ${restaurants[last].name}`
  else if (penultimate == "form") return `Ha ido al formulario para reserva en  ${restaurants[last].name}`
  else if (last == "menus") return `Ha ido a ver los menus de ${restaurants[penultimate].name}`
  else if (penultimate == "menu") return `Ha ido a ver el menu ${restaurants[splittedPath[splittedPath.length - 3]].menus[last].name} de ${restaurants[splittedPath[splittedPath.length - 3]].name}`
  else return path
}

function renderTrackList(trackList) {
  return (
    <ol style={{marginLeft: 10}}>
      {
        trackList.map((track, i) => (
          <li key={`${i}${track}`}>
            {track.pathname} ({track.timestamp && moment(track.timestamp).format("YY/MM/DD HH:mm")})
          </li>
        ))
      }
    </ol>
  )
}

const calendar = date => (
  date 
    ? moment(date).locale("es_es").calendar(null, {
      sameDay: `[Hoy]`,
      lastDay: `[Ayer]`,
      lastWeek: '[El] dddd [pasado] (DD/MM/YYYY)',
      sameElse: 'DD/MM/YYYY'
    })
    : "Sin fecha"
)

class SessionsTable extends React.PureComponent {
  constructor(props) {
    super(props)
    this.pageSizes = [100, 250, 500]
    this.state = {
      modalId: "",
      sessions: []
    }
  }

  componentDidMount() {
    this.props.sessionsInf.then(sessionsInf => {
      this.setState({sessions: sessionsInf.sessions, sessionsLength: sessionsInf.length})
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    nextProps.sessionsInf.then(sessionsInf => {
      if (!isEqual(sessionsInf.sessions, this.props.sessionsInf.sessions)) {
        this.setState({sessions: sessionsInf.sessions, sessionsLength: sessionsInf.length})
      }
    })
  }

  updateQuery(newQuery) {
    console.log({...this.props.query, ...newQuery})
    this.props.updateSearch({...this.props.query, ...newQuery})
  }

  handleSort(sortColumn) {
    if (sortColumn === this.props.query.sortColumn) {
      this.updateQuery({sortDirection: this.props.query.sortDirection == 1 ? -1 : 1})
    }
    else {
      this.updateQuery({
        sortColumn,
        sortDirection: 1
      })
    }
  }

  handleClose() {
    this.setState({ modalId: "" })
  }

  render() {
    const selectedSession = find(this.state.sessions, ["_id", this.state.modalId])
    const { sortColumn, ref } = this.props.query
    const page = this.props.query.page || 0
    const pageSize = this.props.query.pageSize || this.pageSizes[0]
    const sessions = this.state.sessions || []

    const dataWithSep = flatten(sessions.map((r, i) => {
      if (i == 0) {
        return [calendar(r.in), r]
      }
      else if (moment(r.in).format('dddd MMMM YYYY') != moment(sessions[i - 1].in).format('dddd MMMM YYYY')) {
        return [calendar(r.in), r]
      }
      else return r
    }))
    const numPages = Math.ceil(this.state.sessionsLength / pageSize)

    return (
      <div>
        <h1>Ésta página está abandonada, usar <a href="/private/tracking">Tracking</a></h1>
        {sessions
          && (
            <div>
              <div className="sticky">
                <label htmlFor="SupplierFilter">
                  {"Busca cliente/sesion:"}
                </label>
                <FormControl
                  className="input"
                  value={ref}
                  onChange={evt => this.updateQuery({ref: evt.target.value, page: 0})}
                />
              </div>
              {
                numPages > 0 && this.state.sessionsLength > this.pageSizes[0] && (
                  <Pager
                    sizes={this.pageSizes}
                    size={pageSize}
                    numPages={numPages}
                    page={page}
                    onChange={page => this.updateQuery({page})}
                    onSizeChange={pageSize => {
                      this.updateQuery({page: 0, pageSize})
                    }}
                  />
                )
              }
              <div style={{ padding: 10, border: "2px solid dark-grey", borderRadius: "5px" }}>
                <Json src={sessions} />
              </div>
            
              <h1>NEW TABLE</h1>
              
            
              <h1>OLD TABLE</h1>
              <Table bordered className="cool-table">
                <thead>
                  <tr>
                    <th>Id Sesion</th>
                    <th>Id Cliente </th>
                    <th>Direccion IP </th>
                    <th>Query </th>
                    <th>Entrada </th>
                    <th>Salida </th>
                    <th>Pais </th>
                    <th>Ciudad </th>
                    <th>Historial </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    dataWithSep.length == 0 && (
                      <tr><td colSpan="666">No se encontraron resultados</td></tr>
                    )
                  }
                  {
                    dataWithSep.map(session => (
                      isString(session)
                        ? (
                          <tr>
                            <td colSpan="666" className="date-separator">
                              {session}
                            </td>
                          </tr>
                        )
                        : (
                          <tr key={session._id}>
                            <td>{session._id}</td>
                            <td>{session.clientId}</td>
                            <td>{session.ip}</td>
                            <td>
                              {
                                keys(session.query).map(k => (
                                  <div key={k}><b>{k}</b>: {session.query[k]}</div>
                                ))
                              }
                            </td>
                            <td>{session.in && moment(session.in).format("YY/MM/DD HH:mm")}</td>
                            <td>{session.out ? moment(session.out).format("YY/MM/DD HH:mm") : "..."}</td>
                            <td>{session.country}</td>
                            <td>{session.city}</td>
                            <td>
                              <Button bsStyle="link" onClick={() => this.setState({modalId: session._id})}>
                                Ver historial
                              </Button>
                            </td>
                          </tr>
                        )
                    ))
                  }
                </tbody>
              </Table>
              {this.state.modalId
              && (
                <Modal show onHide={() => this.handleClose()}>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      Historial
                      {" "}
                      {selectedSession.clientId}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {renderTrackList(selectedSession.trackList)}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={() => this.handleClose()}>
                      Cerrar
                    </Button>
                  </Modal.Footer>
                </Modal>
              )
              }
            </div>
          )
        }
      </div>

    )
  }
}

const mapStateToProps = (state, props) => ({
  sessionsInf: getSessionsInf(state, props),
  query: parse(state.router.location.search)
})

const mapDispatchToProps = dispatch => ({
  updateSearch: query => dispatch(replace({search: stringify(query)})),
})


export default connect(mapStateToProps, mapDispatchToProps)(SessionsTable)




// WEBPACK FOOTER //
// ./src/app/admin/components/tables/SessionsTable.jsx